class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp);
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class MegaMenuItem extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".mega-menu-sub a");

    this.items.forEach((item) => {
      item.addEventListener("mouseover", this.mouseOver);
      item.addEventListener("focusout", this.onFocusOut.bind(this));
    });

    this.rightItems = this.querySelectorAll(
      ".mega-menu-right .mega-menu-grandchilds:first-child "
    );
    // log.debug(this.rightItems);
    this.rightItems.forEach((item) => {
      item.classList.add("active");
    });
  }

  mouseOver(event) {
    // log.debug(event.currentTarget.dataset.megaHandle);
    var grandchilds = event.currentTarget
      .closest(".mega-menu-item-container")
      .querySelectorAll(".mega-menu-grandchilds");
    // log.debug(grandchilds);

    grandchilds.forEach((item) => {
      if (
        item.dataset.megaSubHandle == event.currentTarget.dataset.megaHandle
      ) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}

customElements.define("mega-menu-item", MegaMenuItem);
